import React from "react";
import { Container, Card, Button } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import CampaignsTab from "./CampaignsTab";
import { Link } from "react-router-dom";

const Campaigns = (props) => {
  //meta title
  document.title = `${props.t("Campaigns")} | ${process.env.REACT_APP_CMS_TITLE}`;

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={props.t("Campaigns")} breadcrumbItem={props.t("จัดการแคมเปญ")} />
          {/* Add your campaigns management content here */}
          <div className="d-flex flex-column gap-4">
            <Card className="card-info p-3 border">
              <div className="d-flex gap-1 align-items-center justify-content-between">
                <h2 className="fw-semibold">สร้างแคมเปญใหม่</h2>
                <Link to={`/campaigns/form`}>
                  <Button color="primary">สร้างแคมเปญ</Button>
                </Link>
              </div>
            </Card>
            <CampaignsTab />
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Campaigns);
